import { Component, inject, signal } from '@angular/core';

import { DepositService } from '../../../service/deposit.service';
import { DepositRedirectService } from '../../../service/depositRedirect.service';
import { UserDataService } from '../../../service/userDataService';
import { PixStatusProcessComponent } from './pix-status-process/pix-status-process.component';
import { WalletProcessComponent } from './wallet-process/wallet-process.component';

@Component({
    selector: 'app-deposit-process',
    templateUrl: './deposit-process.component.html',
    imports: [WalletProcessComponent, PixStatusProcessComponent],
})
export class DepositProcessComponent {
    private depositRedirect = inject(DepositRedirectService);
    private depositService = inject(DepositService);
    private userDataService = inject(UserDataService);

    depositSubmitResponse: any;
    brandId: string = '';
    showPixProcessPage = signal(false);
    processingAmount: number = 0;

    constructor() {
        this.depositSubmitResponse = this.depositRedirect.depositSubmitResponse;
        this.brandId = this.depositService.getLabelName(this.userDataService?.userData?.userInfo) || '';
        this.processingAmount = +this.depositService.submitResponse?.amount?.value || 0;
    }

    updatePageStatus(value: boolean) {
        this.showPixProcessPage.set(value);
    }
}
